import classNames from "classnames";
import style from "./EnhancedSearchResults.module.scss";
import PropTypes from "prop-types";
import { highlightResult } from "../../../utils/resultHighlight";

const SearchResultItem = ({ searchTerm, searchResult, isAppMode = false, showBorder = true }) => {
  let iconClassName = searchResult.guideline.replace(/ /g, "").toLowerCase();
  return (
    <li className={classNames(style.resultChip, { [style.border]: showBorder })}>
      <div className={classNames(style.resultTitleSection)}>
        <a
          href={searchResult.url}
          className={classNames(style.resultTitle, "semibold", {
            "size-20 ": isAppMode !== true,
            "size-16 ": isAppMode === true,
          })}
          dangerouslySetInnerHTML={{
            __html: highlightResult(searchResult.title, searchTerm),
          }}
        ></a>
        <div className={classNames(style.guidelineChip, style.desktopOnly)}>
          <div
            className={classNames(style[iconClassName], style.guidelineIcon)}
          ></div>
          <div className={classNames("size-12", style.guidelineText)}>
            {searchResult.guideline}
          </div>
        </div>
      </div>
      <div
        className={classNames(
          "regular",
          { "size-16": isAppMode !== true, "size-14": isAppMode === true },
          style.resultText,
        )}
        dangerouslySetInnerHTML={{
          __html: highlightResult(searchResult.summary, searchTerm),
        }}
      ></div>
      <div className={classNames(style.guidelineChip, style.mobileOnly)}>
        <div
          className={classNames(style[iconClassName], style.guidelineIcon)}
        ></div>
        <div className={classNames("size-12", style.guidelineText)}>
          {searchResult.guideline}
        </div>
      </div>
    </li>
  );
};

SearchResultItem.propTypes = {
  searchTerm: PropTypes.string,
  isAppMode: PropTypes.bool,
  searchResult: PropTypes.shape({
    guideline: PropTypes.string,
    title: PropTypes.string,
    summary: PropTypes.string,
    url: PropTypes.string,
  }),
};

export default SearchResultItem;
